// minRoll — заложено для единообразия с getD6Roll (подкрутка ботов высоких лиг
// в рейтинговых партиях), но фракция Суккубов исключена из пула ботов, поэтому
// подкрутка сейчас нигде не используется. Честный бросок в диапазоне [minRoll, 20]
export const getD20Roll = (minRoll = 1) => {
  const safeMinRoll = Math.min(20, Math.max(1, minRoll));
  return safeMinRoll + Math.floor(Math.random() * (21 - safeMinRoll));
}
